import React from 'react';
import { ProPerks } from '../ProPerks/ProPerks';
import { ListPageHeader } from '../../commonComponents/ListPageHeader';

/**
 * Pro Programs → Challenges, at `/pro-programs/challenges`.
 *
 * Challenges is the page; ProPerks is one program within it and keeps its own
 * heading below this one, so there is somewhere obvious to hang a second
 * challenge type later.
 *
 * No reading column here, unlike Promotions — ProPerks is a full-width page
 * and must not be squeezed into a narrow one.
 */
export const ChallengesPage = () => (
  <div style={{ padding: '0 16px' }}>
    <ListPageHeader title="Challenges" />
    <ProPerks />
  </div>
);

export default ChallengesPage;
